import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import { validatieStatussenLoaded } from "../../../actions/validatieStatusActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";
import documentApi from "../../../api/shared/documentApi";
import VTTPerOrganisatorForm from "./VTTPerOrganisatorForm";
import AutoBindComponent from "../../common/AutoBindComponent";
import redirector from "../../../util/redirector";
import VTTPerOrganisatorPageHelper from "./VTTPerOrganisatorPageHelper";

class VTTPerOrganisatorPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            model: null,
            tochtTypes: [],
            errors: null,
            hasUnsavedChanges: false,
            deleteTochtTypeTekst: 'tocht'
        };

        this.pageHelper = new VTTPerOrganisatorPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    isReadyToRender = () => {
        return this.state.model;
    };

    handleOnModalOpen = (entityId, tochtTypeText) => this.pageHelper.onModalOpen(entityId, tochtTypeText);
    handleOnModalClose = () => this.pageHelper.onModalClose();
    handleOnDelete = (entityId) => this.pageHelper.onDelete(entityId);
    handleOnNew = () => this.pageHelper.onNew();
    handleOnMailOpmerkingen = () => this.pageHelper.onMailOpmerkingen();

    getPdfDownloadUrl(tochtId) {
        return documentApi.getPdfFileDownloadUrl(tochtId);
    }

    render() {
        if (!this.isReadyToRender())
            return null;

        const state = this.state;
        const model = state.model;
        const disabled = state.disabled;
        const modalIsOpen = state.modalIsOpen;
        const modalEntityId = state.modalEntityId;
        const deleteTochtTypeTekst = state.deleteTochtTypeTekst;

        return (
            <VTTPerOrganisatorForm
                model={model}
                tochtTypes={state.tochtTypes}
                disabled={disabled}
                readonly={false}
                onNew={this.handleOnNew}
                modalIsOpen={modalIsOpen}
                modalEntityId={modalEntityId}
                onModalOpen={this.handleOnModalOpen}
                onModalClose={this.handleOnModalClose}
                onDelete={this.handleOnDelete}
                onMailOpmerkingen={this.handleOnMailOpmerkingen}
                getPdfDownloadUrl={this.getPdfDownloadUrl}
                deleteTochtTypeTekst={deleteTochtTypeTekst}
            />
        );
    }
}

VTTPerOrganisatorPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    const email = state?.referentie?.parameters && state?.referentie?.parameters.find(param => param.value === 'vtT.Emails.HoofdbestuurEmail');

    return {
        email: email?.label
    };


}
function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadVTTPerOrganisatorPageLayout, dispatch),
        validatieStatussenLoaded: bindActionCreators(validatieStatussenLoaded, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VTTPerOrganisatorPage);